import { render } from "./tags.vue?vue&type=template&id=28b8b1b8&lang=pug"
import script from "./tags.vue?vue&type=script&setup=true&lang=js"
export * from "./tags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__